import { render, staticRenderFns } from "./BasicBiographyInfo.vue?vue&type=template&id=9ea78dbc&scoped=true&"
import script from "./BasicBiographyInfo.vue?vue&type=script&lang=js&"
export * from "./BasicBiographyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea78dbc",
  null
  
)

export default component.exports